import WelcomeScreen from './screen-welcome';

export default function RegistrationLayout({right, left}) {
    return (
        <div className="registration-layout">
            <div className="registration-layout__left">
                {left}
            </div>
            <div className="registration-layout__right">
                {right}
            </div>
        </div>
    )
}